'use client';

import { Language, Subsidiary } from '@coolblue-development/constants';
import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import React, { useState } from 'react';

import { CountryLanguageOptions } from '../constants';
import { HeaderDropdown } from '../HeaderDropdown';
import { LanguageOptionsList } from '../LanguageOptionsList';

type Props = {
  allLanguageOptions: Partial<CountryLanguageOptions>;
  isVacancyPage: boolean;
  pageLanguage: Language;
  pageSubsidiary: Subsidiary;
  isHamburgerVariant: boolean;
};

export const LanguageSwitcherDropdown = ({
  allLanguageOptions,
  isVacancyPage,
  pageLanguage,
  pageSubsidiary,
  isHamburgerVariant
}: Props) => {
  const { t } = useTranslation('header.languageSwitcher');

  const [showAllLanguageOptions, setShowAllLanguageOptions] = useState(isVacancyPage);

  return (
    <HeaderDropdown
      variant='unstyled'
      onClose={() => setShowAllLanguageOptions(false)}
      buttonChildren={
        <Typography variant='h3' marginBottom={0} color='inherit'>
          {pageLanguage.toUpperCase()}
        </Typography>
      }
    >
      <Box
        component='div'
        aria-label='Language picker'
        borderRadius={freddyTheme.borderRadius[100]}
        backgroundColor={freddyTheme.color.background.base}
        sx={{ width: '27rem', boxShadow: freddyTheme.shadow.subtle }}
      >
        {!isVacancyPage && showAllLanguageOptions && (
          <Typography
            variant='caption'
            fontWeight={freddyTheme.typography.fontWeight.openSans.normal}
            padding={`${freddyTheme.spacing[200]} ${freddyTheme.spacing[300]} 0`}
            marginBottom={0}
          >
            {t('chooseLanguage')}
          </Typography>
        )}
        <LanguageOptionsList
          allLanguageOptions={allLanguageOptions}
          isVacancyPage={isVacancyPage}
          pageLanguage={pageLanguage}
          pageSubsidiary={pageSubsidiary}
          isHamburgerVariant={isHamburgerVariant}
          showAllLanguageOptions={showAllLanguageOptions}
          setShowAllLanguageOptions={setShowAllLanguageOptions}
        />
      </Box>
    </HeaderDropdown>
  );
};
